import { createContext } from 'react'

import { NICHE_SCOPE_FALLBACK } from './niche-scope.consts'
import type { TUseNicheScopeReturn } from './niche-scope.types'

/**
 * Defaults to the all-`null` fallback so consumers on unscoped routes (no
 * `NicheScopeProvider` mounted) degrade gracefully without throwing.
 */
export const NicheScopeContext = createContext<TUseNicheScopeReturn>(NICHE_SCOPE_FALLBACK)
